import React from 'react';
import PropTypes from 'prop-types';

const HeaderSection = ({ label }) => (
  <div>
    <div className="row micuenta-title">
      <div className="col-lg-4 col-md-4 col-sm-6 col-xs-6">
        <h3>
          <strong>{label.title}</strong>
        </h3>
      </div>
    </div>

    <div className="row">
      <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <p
          className="padding-bottom-2"
          dangerouslySetInnerHTML={{ __html: label.subTitle }}
        />
      </div>
    </div>
  </div>
);

HeaderSection.propTypes = {
  label: PropTypes.object,
};

export default HeaderSection;
